<template>
  <div class="allowance-config">
    <KTCodePreview v-bind:title="'Cấu hình phụ cấp'">
      <template v-slot:toolbar>
        <div class="row">
          <div class="ml-3">
            <b-button variant="primary" size="sm" @click="showConfigModal()">
              <i style="font-size: 1rem" class="flaticon2-add-1"></i>Tạo mới
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-table :items="mainList.dataset" :fields="fields" bordered>
          <template v-slot:cell(isActive)="row">
            <span v-if="row.item.isActive">
              <b-badge variant="success">Hoạt động</b-badge>
            </span>
            <span v-else>
              <b-badge variant="danger">Ngừng hoạt động</b-badge>
            </span>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown size="sm" id="dropdown-left" no-caret right>
              <template slot="button-content">
                <i
                  style="font-size: 1rem; padding-right: 0px"
                  class="flaticon2-settings"
                ></i>
              </template>
              <b-dropdown-item @click="showConfigModal(row.item.id)">
                <span style="color: #3f4254; font-size: 12px">
                  <i
                    style="font-size: 1rem"
                    class="flaticon2-pen icon-color"
                  ></i>
                  &nbsp; Chỉnh sửa
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <AllowanceConfigModal
          ref="allowance-config-modal"
          v-on:on-fetch-data="fetchMainData"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

import { makeToastFaile, convertPrice } from '@/utils/common';
import AllowanceConfigModal from '../../components/allowance-configs/AllowanceConfigModal';
import { TIME_TRIGGER } from '@/utils/constants';

export default {
  components: {
    KTCodePreview,
    AllowanceConfigModal,
  },
  data() {
    return {
      mainList: {
        dataset: [],
        total: 0,
        pages: 1,
      },
      fields: [
        {
          key: 'name',
          label: 'Tên',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'departmentName',
          label: 'Bộ phận',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'jobTitleNames',
          label: 'Chức vụ',
          thStyle: {
            width: '15%',
          },
        },
        {
          key: 'amount',
          label: 'Gói phụ cấp',
          thStyle: {
            width: '10%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return this.convertPrice(value);
          },
        },
        {
          key: 'isActive',
          label: 'Trạng thái',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'createdByName',
          label: 'Người tạo',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'createdAt',
          label: 'Ngày tạo',
          thStyle: {
            width: '10%',
          },
        },
        {
          key: 'actions',
          label: ' ',
          tdClass: 'text-center',
          thStyle: {
            width: '5%',
          },
        },
      ],
      onLoadingList: false,
      apiParams: {
        page: 1,
        limit: 20,
      },
    };
  },
  created() {
    this.fetchMainData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Cấu hình phụ cấp', route: 'allowance-configs' },
    ]);
  },
  methods: {
    convertPrice,
    fetchMainData: async function (page) {
      this.apiParams.page = page ? page : 1;
      this.apiParams.mode = this.$route.params.mode;

      this.onLoadingList = true;
      ApiService.query('/allowance-configs', {
        params: { ...this.apiParams },
      })
        .then((response) => {
          const respData = response.data.data;
          this.mainList = respData;
          this.onLoadingList = false;
        })
        .catch((err) => {
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }
          this.onLoadingList = false;
          this.$nprogress.done();
        });
    },
    showConfigModal(configId) {
      setTimeout(() => {
        this.$refs['allowance-config-modal'].showModal(configId);
      }, TIME_TRIGGER);
    },
  },
};
</script>
<style lang="scss">
.allowance-config {
  table {
    td {
      vertical-align: middle !important;
    }
  }
}
</style>
